import { render } from "./DatePickerComponent.vue?vue&type=template&id=5160ff5e"
import script from "./DatePickerComponent.vue?vue&type=script&lang=js"
export * from "./DatePickerComponent.vue?vue&type=script&lang=js"

import "./DatePickerComponent.vue?vue&type=style&index=0&id=5160ff5e&lang=scss"

import exportComponent from "/home/atnbusrent/public_html/fleet-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__